<template>
  <div :id="$attrs['id']" :class="[$attrs['class'], gridClasses, 'label-value-dotted__wrapper', { 'label-value-dotted__wrapper--clickable': clickable }]" @click="$emit('click')">
    <span class="label-value-dotted__label" v-html="label"></span>
    <span class="label-value-dotted__dotted"></span>
    <span :class="valueClass" class="label-value-dotted__value" v-html="displayValue"></span>
  </div>
</template>

<script>
import GridMixin from '@/mixins/GridMixin';

export default {
  name: 'LabelValueDotted',

  mixins: [GridMixin],

  props: {
    label: String,
    value: {
      required: true,
    },
    unit: {
      type: String,
      default: '',
      required: false,
    },
    clickable: {
      type: Boolean,
      default: false,
      required: false,
    },
    valueClass: {
      required: false,
    },
  },

  computed: {
    displayValue: function () {
      return `${this.value} ${this.unit}`.trim();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~styles/import';

  .label-value-dotted {
    &__wrapper {
      display: grid;
      grid-template-columns: max-content auto max-content;
      grid-column-gap: 0.5rem;
      width: 100%;
      margin-bottom: 1rem;
      &--bold {
        font-weight: bold;
      }
      &--sum {
        margin-top: 16px;
      }

      &--clickable {
        cursor: pointer;

        &:hover {
          color: $mint;
        }
      }
    }

    &__dotted {
      border-bottom: 1px dotted $middlegray;
      margin-bottom: 4px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/util/LabelValueDotted.vue